import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { useFormik } from 'formik';
import { ReactElement, useCallback } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import * as yup from 'yup';

interface initalValuesProps {
  id?: number | string;
  code?: string;
  description?: string;
}

interface Props {
  title: string;
  onCancel: () => void;
  onOk: (form?: initalValuesProps) => void;
  children?: ReactElement;
  disabled?: boolean;
  forminitialValues?: initalValuesProps;
  isEdit?: boolean;
}

const validationSchema = yup.object({
  id: yup.string().nullable().notRequired(),
  code: yup.string().nullable().required('Il campo è obbligatorio'),
  description: yup.string().nullable().required('La descrizione è obbligatorio'),
});

const TypesEventForm = ({
  title,
  onCancel,
  disabled = false,
  forminitialValues,
  onOk,
  isEdit,
}: Props): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const typesEventForm = useFormik({
    initialValues: forminitialValues || {
      code: '',
      description: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
  });
  return (
    <>
      <Card raised className="pmi-my-3">
        <form onSubmit={typesEventForm.handleSubmit}>
          <CardContent style={{ padding: '24px' }}>
            <Typography gutterBottom variant="h5" component="h2">
              {title}
            </Typography>
            <div style={{ padding: '24px 0 0 0' }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    label="Codice *"
                    id="code"
                    name="code"
                    fullWidth
                    type="text"
                    disabled={disabled || isEdit}
                    value={typesEventForm.values.code}
                    onChange={typesEventForm.handleChange}
                    error={Boolean(typesEventForm.errors.code) && typesEventForm.touched.code}
                    helperText={typesEventForm.errors.code}
                    variant="outlined"
                    inputProps={{
                      maxLength: '5',
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <PmiTextField
                    label="Descrizione *"
                    id="description"
                    name="description"
                    disabled={disabled}
                    value={typesEventForm.values.description}
                    onChange={typesEventForm.handleChange}
                    error={
                      Boolean(typesEventForm.errors.description) &&
                      typesEventForm.touched.description
                    }
                    helperText={typesEventForm.errors.description}
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputProps={{
                      maxLength: '100',
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </CardContent>
          <CardActions style={{ padding: '24px 24px 16px 24px' }}>
            {!disabled ? (
              <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
                Conferma
              </PmiButton>
            ) : null}
            <PmiButton variant="outlined" color="cdmBrand" onClick={onCancel}>
              Indietro
            </PmiButton>
          </CardActions>
        </form>
      </Card>
    </>
  );
};

TypesEventForm.displayName = 'Types Event form component';
export default TypesEventForm;
